import React from 'react'
import {Box, Text, StackProps, TextProps, useMultiStyleConfig} from '@chakra-ui/react'

interface AlertMessageProps {
    children: React.ReactNode
}

/**
 * @name AlertMessage
 *
 * @description
 * Component that wraps error.
 *
 * @component
 * @param {props} props - children.
 *
 * @returns {JSX.Element} The rendered AlertMessage component.
 *
 */

const AlertMessage = ({children}: AlertMessageProps): JSX.Element => {
    const styles = useMultiStyleConfig('AlertMessage') as Record<string, StackProps & TextProps>
    return (
        <Box {...styles.errorBox} data-testid="alert-message">
            <Text {...styles.errorMessage}>{children}</Text>
        </Box>
    )
}

export {AlertMessage}
